import { notification } from 'antd';
import axios from 'axios';
import NoImage from '../assets/icon/noimage.png';

// Default placeholder image from src assets (bundled path)
export const DEFAULT_THUMB = NoImage;

export const checkValidUpload = (file, MAX_SIZE_MB = 3) => {
  const isTooLarge = file.size / 1024 / 1024 > MAX_SIZE_MB;

  if (isTooLarge) {
    notification.error({
      message: 'Kích thước ảnh quá lớn!',
      description: `Vui lòng chọn ảnh nhỏ hơn ${MAX_SIZE_MB}MB.`,
    });
    return false;
  }
  return true;
};

// Format date to dd/mm/YYYY
export const formatDateVN = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (isNaN(date)) return value;
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
};

export function newObjectKeys(originalObject, necessaryKeys) {
  return Object.fromEntries(
    Object.entries(originalObject)
      .filter(([key, value]) => necessaryKeys.includes(key))
      .map(([key, value]) => [key, value])
  );
}

export async function uploadImageCDN(img, callback, uploadFolder = '') {
  const FILE_UPLOAD = process.env.REACT_APP_UPLOAD_FILE_API_ENDPOINT;
  const data = new FormData();
  data.append('files', img);
  data.append('uploadFolder', uploadFolder);
  const user = localStorage.getItem('user');
  const decodeUser = JSON.parse(user);
  const response = await axios
    .post(FILE_UPLOAD, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Stoken: decodeUser?.token,
      },
    })
    .catch((err) => {
      console.log(err);
      return err;
    });

  if (response?.data?.status) {
    callback(response.data?.path);
    const cdn = process.env.REACT_APP_CDN_DOMAIN || '';
    const base = cdn.replace(/\/$/, '');
    const path = response.data?.path || '';
    return `${base}${path}`;
  } else {
    callback('');
    notification.error({
      message: response?.data?.message || 'Có lỗi xảy ra, vui lòng thử lại!',
    });
  }
}

export const formatPrice = (n, str = '.') => {
  var a = n?.toString().replaceAll('.', '').replaceAll(',', '');
  return a?.replace(/./g, function (c, i, a) {
    return i > 0 && c !== str && (a.length - i) % 3 === 0 ? str + c : c;
  });
};

export const formatNumber = (value) => {
  if ((value == null || value === undefined || value === '') && (value !== 0 || value !== '0')) {
    return '';
  }
  if (!isNaN(value)) {
    return Number(value).toLocaleString('de-DE');
  }
  return value.toString();
};

export const dataToOptionSelect = (data, label = 'name', value = 'id') => {
  return data?.map((item) => ({
    label: item[label],
    value: item[value],
  }));
};
